export default "__VITE_ASSET__DNdtolnB__"